import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade , Thumbs } from 'swiper/modules';
import 'swiper/css/bundle';
import AOS from 'aos';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);
window.Swiper = Swiper;

// JavaScript
$(function () {
  //scroll top
  // $('.back-to-top').click(function(event){
  //   $("html,body").animate({scrollTop: 0}, 1000);
  // });
  AOS.init();

  // transparent header
  function headerScroll() {
    if ($(window).scrollTop() > 100) {
      $('.header').addClass("min-header");
    } else {
      $('.header').removeClass("min-header");
    }
  }
  headerScroll();
  $(window).on('scroll', function () {
    headerScroll();
  });

  $('.header-mobile-menu').on('click', function () {
    $(this).toggleClass('active');
    $('.header-menu-outer').toggleClass('active');
  });

  $('.menu-link').click(function(e) {
      $(this).parent().toggleClass('active').siblings().removeClass('active');
  });

  var indexBanner = new Swiper('#indexBanner', {
    effect: 'fade',
    // autoplay: {
    //   delay: 5000,
    // },
    loop: true,
    peed: 1000,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
  });

  // dropdown
  $('.dropdown-btn').on('click', function () {
    const id = $(this).attr('id');
    const dropdown_is_active = $('[aria-labelledby=' + id + ']').hasClass("is-active");
    if (dropdown_is_active >= 1) {
      $('[aria-labelledby=' + id + ']').removeClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '',
          'overflow': '',
        })
      }
    } else {
      $(".dropdown-list:not([aria-labelledby=" + id + "]").removeClass('is-active');
      $('[aria-labelledby=' + id + ']').addClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '100vh',
          'overflow': 'hidden',
        })
      }
    }
  });

  $(document).click(function (event) {
    if (!$(event.target).closest('.dropdown-btn').length) {
      if ($('.dropdown-list').is(":visible")) {
        $(".dropdown-list").removeClass('is-active');
        if (window.innerWidth <= 640) {
          $('body').css({
            'height': '',
            'overflow': '',
          })
        }
      }
    }
  });

  // 【通用元件】選單收合(單層)
  $(".accordion-btn").on("click", function () {
    $(this).closest(".accordion-item").toggleClass('active');
  });

  // Index Page - About Swiper
  var swiper = new Swiper("#aboutSwiper", {
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      801: {
        slidesPerView: 2,
      },
      1025: {
        slidesPerView: 3,
      },
      1281: {
        slidesPerView: 4,
      },
    },
    spaceBetween: 12,
    navigation: {
      nextEl: ".about .swiper-btns-wrapper .swiper-button-next",
      prevEl: ".about .swiper-btns-wrapper .swiper-button-prev",
    },
    loop: true,
  });

  // Index Page - Partner
  var partnerSwiper = new Swiper("#partnerSwiper", {
    loop: true,
    breakpoints: {
      0: {
        slidesPerView: 3,
      },
      641: {
        slidesPerView: 4,
      },
      801: {
        slidesPerView: 5,
      },
      1025: {
        slidesPerView: 6,
      },
      1281: {
        slidesPerView: 7,
      },
    },
  });
  // Index Page - Clients Swiper
  var clientSwiper = new Swiper("#clientSwiper", {
    slidesPerView: 1,
    navigation: {
      nextEl: ".clients .swiper-btns-wrapper .swiper-button-next",
      prevEl: ".clients .swiper-btns-wrapper .swiper-button-prev",
    },
    loop: true,
  });

  // Index Page - Videos Swiper
  const videoSwiper = new Swiper('#videoSwiper', {
    navigation: {
      nextEl: '.video-section .swiper-btns-wrapper .swiper-button-next',
      prevEl: '.video-section .swiper-btns-wrapper .swiper-button-prev'
    },
    breakpoints: {
      0: {
        slidesPerView: 3,
        spaceBetween: 8,
      },
      801: {
        slidesPerView: 4,
        spaceBetween: 12,
      },
      1025: {
        slidesPerView: 5,
        spaceBetween: 16,
      }
    }
  });

  // search
  $('#search_btn').on('click', function() {
    $('#search_popup').addClass('is-active');
  })
  $('.search-popup-close, .search-popup-mask').on('click', function() {
    $('#search_popup').removeClass('is-active');
  })

  // search tab
  $('.tab[data-tab]').on('click', function () {
    var tabPanes = $(this).data('tabs');
    var ID = $(this).data('tab');
    $(this).addClass('is-active').siblings().removeClass('is-active');
    $("[data-tab-panes=" + tabPanes + "]").find("[data-tab-pane=" + ID + "]").addClass('is-active').siblings().removeClass('is-active');
  });

  const clearButton = document.getElementById("clear-button");
  const searchInput = document.getElementById("searchKeyword");
  const tsControlInput = document.querySelector('.ts-control .item');


  clearButton.addEventListener("click", function () {
    searchInput.value = "";

    if (tsControlInput) {
      tsControlInput.innerHTML = "";
      tsControlInput.removeAttribute('data-value');
    }
    searchInput.focus();
  });

  $('.video-thumb').on('click', function () {
    const videoId = $(this).data('youtube-id');
    const newSrc = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    $('.video-thumb-slide').removeClass('selected');
    $(this).closest('.video-thumb-slide').addClass('selected');

    $('#main-video').attr('src', newSrc);
  });

  // About - 成長足跡
  if ($('.milestone-item').length > 0) {
    const itemsByYear = {};

    $('.milestone-item').each(function () {
      const $item = $(this);
      const dateText = $item.find('.milestone-date').text().trim();
      const year = dateText.slice(0, 4); // 取前4碼做為年份

      if (!itemsByYear[year]) {
        itemsByYear[year] = [];
      }
      itemsByYear[year].push($item);
    });

    $.each(itemsByYear, function (year, items) {
      const first = items[0];
      const last = items[items.length - 1];

      // 加上 .first-of-year 並填入年份文字
      first.addClass('first-of-year');
      first.find('.milestone-year').text(year);

      // 加上 .last-of-year
      last.addClass('last-of-year');
    });
  }

  // About - 媒體報導
  const featuredNewsSwiper = new Swiper('#featuredNewsSwiper', {
    breakpoints: {
      0: {
        slidesPerView: 1.4,
        spaceBetween: 8,
      },
      641: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      801: {
        slidesPerView: 3,
        spaceBetween: 12,
      },
      1025: {
        slidesPerView: 4,
        spaceBetween: 16,
      }
    }
  });

  // Products - 產品分類 Swiper
  const productTabsSwiper = new Swiper('#productTabsSwiper', {
    breakpoints: {
      0: {
        slidesPerView: 4.5,
        spaceBetween: 8,
      },
      481: {
        slidesPerView: 5.5,
        spaceBetween: 8,
      },
      641: {
        slidesPerView: 6,
        spaceBetween: 10,
      },
      801: {
        slidesPerView: 8,
        spaceBetween: 12,
      },
      1025: {
        slidesPerView: 9,
        spaceBetween: 32,
      }
    },
    navigation: {
      nextEl: ".prod-cate-container .swiper-button-next",
      prevEl: ".prod-cate-container .swiper-button-prev",
    },
    loop: true,
  });

  // 產品篩選器
  $('#filterSwitchBtn').on('click', function () {
    const $filter = $('#prodFilter');
    $filter.toggleClass('active');

    // 先移除舊的監聽（避免重複）
    $(document).off('click.filterOutside');

    // 如果打開了，就綁定空白處點擊事件
    if ($filter.hasClass('active')) {
      setTimeout(() => { // 用 setTimeout 避免立即觸發關閉（因為點擊開啟按鈕本身）
        $(document).on('click.filterOutside', function (e) {
          if (
            !$filter.is(e.target) &&
            $filter.has(e.target).length === 0 &&
            !$('#filterSwitchBtn').is(e.target) &&
            $('#filterSwitchBtn').has(e.target).length === 0
          ) {
            $filter.removeClass('active');
            $(document).off('click.filterOutside'); // 關掉後取消監聽
          }
        });
      }, 0);
    }
  });

  $('#prodFilter .close-btn-mb').on('click', function(){
    if($('#prodFilter').hasClass('active')) {
      $('#prodFilter').removeClass('active');
    }
  });

  // 產品內頁圖片Swiper－縮圖
  const productImgSwiperThumb = new Swiper('#postInnerThumbnail', {
    loop: false,
    spaceBetween: 12,
    pagination: {
      el: '.swiper-pagination', // 如果有分頁器
      clickable: true,
    },
    slidesPerView: 3.3, // 每次顯示3張縮圖
    watchSlidesProgress: true,
    freeMode: false,
    direction: 'vertical',
  });

  // 產品內頁圖片Swiper－主圖片
  const productImgSwiper = new Swiper('#postInnerBanner', {
    loop: true,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next', // 如果有導航按鈕
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination', // 如果有分頁器
      clickable: true,
    },
    thumbs: {
      swiper: productImgSwiperThumb,
    }
  });

  // 服務流程 Scroll
  function serviceScroll() {
    const $bar = $('.service-step-bar');
    if (!$bar.length) return;// 沒有這個區塊就直接跳出，不執行

    const stickyTop = parseInt($bar.css('top'), 10) || 0; // sticky 設定的 top 值
    const rectTop = $bar[0].getBoundingClientRect().top;
    const tolerance = 1; // 誤差容忍值，避免scrollbar抖動

    if (rectTop <= stickyTop + tolerance) {
      if (!$bar.hasClass('bar-collapse')) {
        $bar.addClass('bar-collapse');
      }
    } else {
      if ($bar.hasClass('bar-collapse')) {
        $bar.removeClass('bar-collapse');
      }
    }
  }

  // 初始執行一次
  serviceScroll();

  // 滾動/縮放時持續檢查
  $(window).on('scroll resize', serviceScroll);

  // ---- Scroll Spy ----
  const $blocks = $(".step-phase-block");
  const $steps = $(".service-step-bar .service-step");
  const $progressBar = $(".service-stepper .progress-bar");
  const offsetTop = 252; // 預留高度 (例如 header 高度)

  if ($blocks.length && $steps.length && $progressBar.length) {
    $(window).on("scroll", function() {
      const scrollTop = $(this).scrollTop();
      let currentIndex = 0;

      $blocks.each(function(i) {
        const blockTop = $(this).offset().top - offsetTop;
        if (scrollTop >= blockTop) {
          currentIndex = i;
        }
      });

      /// 所有 step 重置，再依照 currentIndex 之前的都加上 active
      $steps.removeClass("active");
      $steps.each(function(i) {
        if (i <= currentIndex) {
          $(this).addClass("active");
        }
      });

      updateProgressBar(currentIndex);
    }).trigger("scroll");
  }

  // ---- Click to scroll ----
  $steps.on("click", function(e) {
    e.preventDefault();
    const index = $(this).index(); // 取得 step 的索引
    const targetTop = $blocks.eq(index).offset().top - offsetTop + 1;

    $("html, body").animate(
      { scrollTop: targetTop },
      600, // 動畫時間
      "swing",
      function() {
        updateProgressBar(index);

        // 點擊時，也要確保前面的 step 全部 active
        $steps.removeClass("active");
        $steps.each(function(i) {
          if (i <= index) {
            $(this).addClass("active");
          }
        });
      }
    );
  });

  // ---- 更新 progress-bar 的函數 ----
  function updateProgressBar(index) {
    const totalSteps = $steps.length;
    const percent = (index / (totalSteps - 1)) * 100;

    // 產生 linear-gradient 字串
    const gradient = `linear-gradient(to right,
      #FFAB2D 0%,
      #FFAB2D ${percent}%,
      #DFDFDF ${percent + 1}%,
      #DFDFDF 100%)`;

    $progressBar.css("background-image", gradient);
  }

  // 材質介紹 - 材質項目開關功能
  $('.material-item').on('click', function(e){
    e.preventDefault();

    if ($(this).hasClass('accessory-item')) return;

    $('.material-item').removeClass('active');
    $(this).addClass('active');

    $('.material-item.active .close-btn').on('click', function(e){
      e.stopPropagation();
      $('.material-item').removeClass('active');
    });
  });

  // float-btn
  var $floatBtns = $('.float-btns');
  var $staticBtn = $floatBtns.find('.float-btn.static');

  // 桌面：滑鼠移入/移出
  $floatBtns.hover(
    function() { $floatBtns.addClass('active'); },
    function() { $floatBtns.removeClass('active'); }
  );

  // 判斷是否手機版
  function isMobile() {
    return $(window).width() < 800;
  }

  // 手機：點擊 static 按鈕切換 active
  if (isMobile()) {
    $staticBtn.on('touchstart click', function(e) {
      if (!$floatBtns.hasClass('active')) {
        e.preventDefault();   // 阻止預設直接跳轉
        $floatBtns.addClass('active'); // 顯示浮動按鈕
      }
      // 如果已經 active，就不阻止，允許跳轉
    });

    // 點擊外部區域取消 active
    $(document).on('touchstart click', function(e) {
      if (!$(e.target).closest('.float-btns').length) {
        $floatBtns.removeClass('active');
      }
    });
  }
});

